import {
  AfterViewInit,
  Component,
  ElementRef,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Auth0Service } from '@geneplanet/ngx-auth0';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalService } from 'src/app/shared/services/modal.service';
import { CookieSettingsModalComponent } from '../cookie-settings/cookie-settings-modal.component';
import {
  CookieSettings,
  defaultAcceptedCookieSettings,
} from '../cookie-settings/cookie.types';
import { CookiesService } from '../cookie.service';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CookieConsentComponent implements AfterViewInit {
  cookiesAccepted = false;
  LScookiesSettings = '@geneplanet/cookie_settings';
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    private readonly modalService: ModalService,
    private cookiesService: CookiesService,
    private auth0: Auth0Service
  ) {
    const cSettings: { configured: boolean } = JSON.parse(
      window.localStorage.getItem(this.LScookiesSettings)
    );
    if (cSettings && cSettings.configured) {
      this.cookiesAccepted = true;
      this.updateView();
    } else {
      this.cookiesService.cookiesAccepted$
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((r) => {
          if (r) {
            this.cookiesAccepted = true;
            this.updateView();
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
          }
        });
    }
  }

  ngAfterViewInit() {
    if (
      !this.cookiesAccepted ||
      !this.cookiesService.checkIfConfiguredCookieExists()
    ) {
      this.auth0.tokens.current$
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((account) => {
          if (account) {
            this.cookiesService.acceptAllCookies();
            this.cookiesAccepted = true;
            this.updateView();
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
          } else {
            const atLeastOneAccepted = this.cookiesService.checkIfAtLeastOneAccepted();
            if (atLeastOneAccepted) {
              this.cookiesAccepted = true;
              this.updateView();
              this.ngUnsubscribe.next();
              this.ngUnsubscribe.complete();
            } else {
              this.cookiesService.saveCookiesFirstPageView();
              this.updateView();
            }
          }
        });
    }
  }

  showCookiePolicy() {
    this.router.navigateByUrl('cookie-policy');
  }

  openCookieSettings() {
    const ref = this.modalService.openFullScreen(CookieSettingsModalComponent);

    ref.result.then(
      (data: CookieSettings) => {
        // on close
        if (data) {
          this.cookiesService.saveCookies(data);
          this.cookiesService.saveConfiguredCookie(
            Object.values(data).filter((d) => !d).length === 0
          );
        } else {
          this.cookiesService.saveConfiguredCookie(false);
        }
        this.updateView();
      },
      () => {
        // on dismiss
      }
    );
  }

  acceptCookies(configure = true) {
    this.cookiesService.saveCookies(defaultAcceptedCookieSettings);
    // Temporary fix, show popup until user interact with the popup
    if (configure) {
      this.cookiesService.saveConfiguredCookie(true);
    }
    this.cookiesAccepted = true;
    this.updateView();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private updateView() {
    if (this.cookiesService.checkIfConfiguredCookieExists()) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'block');
    }
  }
}
